import { LoginForm } from "@/components/login-form"
import logo from '../assets/logo.png';
import { useEffect } from "react";
import { clearCache } from "@/lib/indexedDbCache";

function Login() {
  useEffect(() => {
    sessionStorage.clear();
    localStorage.clear();
    clearCache();
  },[])
  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10 bg-[#f8f2e8]">
      <div className="w-full max-w-sm">
        <img src={logo} alt="Pabandi Portal Logo" className="justify-self-center" width="200" />
        <LoginForm />
      </div>
    </div>
  )
}

export default Login